import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing }) => ({
  root: {
    display: "flex",
    height: "calc(100vh - 108px)",
    justifyContent: "center",
    alignItems: "center",
  },
  copyright: {
    marginBottom: spacing(5),
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    width: 400,
    margin: "auto",
    border: `1px solid ${grey[300]}`,
    borderRadius: spacing(1),
    backgroundColor: "#ffffff",
    padding: spacing(3),
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: spacing(3),
    width: "100%",
  },
  title: {
    lineHeight: 1,
    fontWeight: 500,
  },
}));

export default styles;
